import ContactUsLocationCard from "@components/BasicComponents/Cards/ContactUsLocationCard/ContactUsLocationCard"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./ContactUsLocationSection.module.scss"

const ContactUsLocationSection = (props: {
	data: AdvancedSideAssetModuleType
}) => {
	const mainContent = props.data.mainContent

	const hasTitleOrSubtitles =
		props.data.sectionTitle || props.data.sectionSubtitle

	return (
		<section id={"locations"}>
			<ContainerWrapper>
				{(props.data.sectionTitle || props.data.sectionSubtitle) && (
					<>
						<Separator />
						<Typography
							className={styles.cardsCeoSectionTitle}
							content={props.data.sectionTitle}
							variant={Variant.Title}
							size={Size.M}
						/>
						<Typography
							className={styles.cardsCeoTitle}
							content={props.data.sectionSubtitle}
							variant={Variant.Paragraph}
							fontWeight={300}
							size={Size.M}
						/>
					</>
				)}

				<Separator
					className={`${styles.locationContainer} ${
						!hasTitleOrSubtitles ? styles.border : ""
					}`}
					size={32}
				>
					{mainContent?.map(
						(
							element: AdvancedSideAssetMainContent,
							index: number,
						) => {
							return (
								<ContactUsLocationCard
									key={index}
									className={styles.locationBox}
									data={element}
								/>
							)
						},
					)}
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default ContactUsLocationSection
